(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-stories"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Touch ve mouse olayları için kaydırma desteği
  const storiesWrapper = document.querySelector('.instagram-stories-wrapper');
  
  if (storiesWrapper) {
    let isDown = false;
    let startX;
    let scrollLeft;
    
    // Mouse olayları
    storiesWrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - storiesWrapper.offsetLeft;
      scrollLeft = storiesWrapper.scrollLeft;
    });
    
    storiesWrapper.addEventListener('mouseleave', () => {
      isDown = false;
    });
    
    storiesWrapper.addEventListener('mouseup', () => {
      isDown = false;
    });
    
    storiesWrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - storiesWrapper.offsetLeft;
      const walk = (x - startX) * 2; // Kaydırma hızı
      storiesWrapper.scrollLeft = scrollLeft - walk;
    });
    
    // Touch olayları
    storiesWrapper.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX - storiesWrapper.offsetLeft;
      scrollLeft = storiesWrapper.scrollLeft;
    });
    
    storiesWrapper.addEventListener('touchend', () => {
      isDown = false;
    });
    
    storiesWrapper.addEventListener('touchcancel', () => {
      isDown = false;
    });
    
    storiesWrapper.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - storiesWrapper.offsetLeft;
      const walk = (x - startX) * 2;
      storiesWrapper.scrollLeft = scrollLeft - walk;
    });
  }
  
  // Reels işlevselliği için global değişkenler
  window.currentCollection = '';
  window.currentSlideIndex = 0;
  window.slidesData = {};
  
  // Reels modal açma fonksiyonu
  window.openReelsModal = function(collectionHandle) {
    window.currentCollection = collectionHandle;
    window.currentSlideIndex = 0;
    
    // Eğer bu koleksiyon için veriler daha önce yüklenmediyse, yükle
    if (!window.slidesData[collectionHandle]) {
      fetchCollectionProducts(collectionHandle);
    } else {
      // Veriler zaten yüklenmişse, reels'i göster
      showReelsSlides(window.slidesData[collectionHandle]);
    }
    
    document.getElementById('reelsModal').style.display = 'block';
  };
  
  // Reels modal kapatma fonksiyonu
  window.closeReelsModal = function() {
    document.getElementById('reelsModal').style.display = 'none';
    
    // Video varsa durdur
    const activeSlide = document.querySelector('.reels-slide.active');
    if (activeSlide) {
      const video = activeSlide.querySelector('video');
      if (video) {
        video.pause();
      }
    }
  };
  
  // Koleksiyon ürünlerini getirme fonksiyonu
  function fetchCollectionProducts(collectionHandle) {
    fetch(`/collections/${collectionHandle}?view=json`)
      .then(response => response.json())
      .then(data => {
        // Verileri kaydet
        window.slidesData[collectionHandle] = data.products;
        // Reels'i göster
        showReelsSlides(data.products);
      })
      .catch(error => {
        console.error('Ürünler yüklenirken hata oluştu:', error);
        // Hata durumunda alternatif yöntem
        fetchCollectionProductsAlternative(collectionHandle);
      });
  }
  
  // Alternatif ürün getirme yöntemi (JSON view yoksa)
  function fetchCollectionProductsAlternative(collectionHandle) {
    fetch(`/collections/${collectionHandle}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productElements = doc.querySelectorAll('.product-card');
        
        const products = Array.from(productElements).map(element => {
          const productUrl = element.querySelector('a').href;
          const productTitle = element.querySelector('.product-card__title').textContent.trim();
          const productImage = element.querySelector('img').src;
          const productId = productUrl.split('/products/')[1];
          
          // Ürünün tüm medya öğelerini almaya çalış
          const mediaElements = element.querySelectorAll('img, video');
          const mediaUrls = Array.from(mediaElements).map(media => media.src || media.dataset.src);
          
          return {
            id: productId,
            title: productTitle,
            url: productUrl,
            featured_image: productImage,
            images: mediaUrls,
            media_type: element.querySelector('video') ? 'video' : 'image'
          };
        });
        
        // Verileri kaydet
        window.slidesData[collectionHandle] = products;
        // Reels'i göster
        showReelsSlides(products);
      })
      .catch(error => {
        console.error('Alternatif yöntemle ürünler yüklenirken hata oluştu:', error);
      });
  }
  
  // Reels slaytlarını gösterme fonksiyonu
  window.showReelsSlides = function(products) {
    const slidesContainer = document.querySelector('.reels-slides-container');
    slidesContainer.innerHTML = ''; // Önceki slaytları temizle
    
    const collectionHandle = window.currentCollection;
    const collectionUrl = `/collections/${collectionHandle}`;
    
    // Her ürün için bir slayt oluştur
    products.forEach((product, index) => {
      const slide = document.createElement('div');
      slide.className = 'reels-slide';
      if (index === window.currentSlideIndex) {
        slide.classList.add('active');
      }
      
      // Ürün medyası (resim veya video)
      const imageContainer = document.createElement('div');
      imageContainer.className = 'reels-image-container';
      
      // Medya türünü kontrol et
      if (product.media_type === 'video' || (product.featured_media && product.featured_media.media_type === 'video')) {
        // Video
        const video = document.createElement('video');
        video.className = 'reels-video';
        video.src = product.featured_image || product.images[0];
        video.controls = true;
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        
        imageContainer.appendChild(video);
      } else {
        // Resim
        const image = document.createElement('img');
        image.className = 'reels-image';
        
        // Önce ikinci resmi kullanmaya çalış, yoksa ilk resmi kullan
        if (product.images && product.images.length > 1) {
          image.src = product.images[1];
        } else {
          image.src = product.featured_image || (product.images && product.images[0]);
        }
        
        image.alt = product.title;
        
        imageContainer.appendChild(image);
      }
      
      // Ürün bilgileri
      const info = document.createElement('div');
      info.className = 'reels-info';
      
      const title = document.createElement('div');
      title.className = 'reels-title';
      title.textContent = product.title;
      
      const buttons = document.createElement('div');
      buttons.className = 'reels-buttons';
      
      const productBtn = document.createElement('a');
      productBtn.className = 'reels-button reels-product-btn';
      productBtn.textContent = 'Ürüne Git';
      productBtn.href = product.url;
      
      const collectionBtn = document.createElement('a');
      collectionBtn.className = 'reels-button reels-collection-btn';
      collectionBtn.textContent = 'Koleksiyona Git';
      collectionBtn.href = collectionUrl;
      
      buttons.appendChild(productBtn);
      buttons.appendChild(collectionBtn);
      
      info.appendChild(title);
      info.appendChild(buttons);
      
      slide.appendChild(imageContainer);
      slide.appendChild(info);
      
      slidesContainer.appendChild(slide);
    });
    
    // İlk slayttaki videoyu otomatik oynat
    const activeSlide = document.querySelector('.reels-slide.active');
    if (activeSlide) {
      const video = activeSlide.querySelector('video');
      if (video) {
        video.play().catch(e => console.log('Video otomatik oynatılamadı:', e));
      }
    }
  };
  
  // Önceki slayta geçme fonksiyonu
  window.prevReelsSlide = function() {
    const products = window.slidesData[window.currentCollection];
    if (!products || products.length === 0) return;
    
    const slides = document.querySelectorAll('.reels-slide');
    
    // Mevcut slayttaki videoyu durdur
    const currentSlide = slides[window.currentSlideIndex];
    const currentVideo = currentSlide.querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
    }
    
    // Mevcut slaytı gizle
    slides[window.currentSlideIndex].classList.remove('active');
    
    // Önceki slayta geç
    window.currentSlideIndex--;
    if (window.currentSlideIndex < 0) {
      window.currentSlideIndex = slides.length - 1;
    }
    
    // Yeni slaytı göster
    slides[window.currentSlideIndex].classList.add('active');
    
    // Yeni slayttaki videoyu oynat
    const newSlide = slides[window.currentSlideIndex];
    const newVideo = newSlide.querySelector('video');
    if (newVideo) {
      newVideo.play().catch(e => console.log('Video otomatik oynatılamadı:', e));
    }
  };
  
  // Sonraki slayta geçme fonksiyonu
  window.nextReelsSlide = function() {
    const products = window.slidesData[window.currentCollection];
    if (!products || products.length === 0) return;
    
    const slides = document.querySelectorAll('.reels-slide');
    
    // Mevcut slayttaki videoyu durdur
    const currentSlide = slides[window.currentSlideIndex];
    const currentVideo = currentSlide.querySelector('video');
    if (currentVideo) {
      currentVideo.pause();
    }
    
    // Mevcut slaytı gizle
    slides[window.currentSlideIndex].classList.remove('active');
    
    // Sonraki slayta geç
    window.currentSlideIndex++;
    if (window.currentSlideIndex >= slides.length) {
      window.currentSlideIndex = 0;
    }
    
    // Yeni slaytı göster
    slides[window.currentSlideIndex].classList.add('active');
    
    // Yeni slayttaki videoyu oynat
    const newSlide = slides[window.currentSlideIndex];
    const newVideo = newSlide.querySelector('video');
    if (newVideo) {
      newVideo.play().catch(e => console.log('Video otomatik oynatılamadı:', e));
    }
  };
  
  // ESC tuşu ile modalı kapatma
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeReelsModal();
    }
  });
  
  // Modal dışına tıklayarak kapatma
  const modal = document.getElementById('reelsModal');
  modal.addEventListener('click', function(event) {
    if (event.target === modal) {
      closeReelsModal();
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
